
export default {
  mounted () {
    document.addEventListener('scroll', function () {
      if (document.querySelector('#title') !== null) {
        var top = window.pageYOffset + window.innerHeight,
          title = top > document.querySelector('#title').offsetTop,
          certificate = top > document.querySelector('#certificate').offsetTop + 100
      }
      if (title) {
        document.getElementById('title').classList.add('fadeInUp')
      }
      if (certificate) {
        document.getElementById('certificate').classList.add('fadeInUp')
      }
    })
  },
  data () {
    return {
      data: [
        {
          id: 1,
          img: require('@/assets/img/logo-cer-01.png'),
        },
        {
          id: 2,
          img: require('@/assets/img/logo-cer-02.png')
        },
        {
          id: 3,
          img: require('@/assets/img/logo-cer-03.png')
        },
        {
          id: 4,
          img: require('@/assets/img/logo-cer-03-2.png')
        },
        // {
        //   id: 3,
        //   combine: true,
        //   FirstImg: require('@/assets/img/logo-cer-03.png'),
        //   SecoundImg: require('@/assets/img/logo-cer-03-2.png')
        // },
        {
          id: 5,
          img: require('@/assets/img/logo-cer-04.png')
        },
        {
          id: 6,
          img: require('@/assets/img/logo-cer-05.png')
        },
        {
          id: 7,
          img: require('@/assets/img/logo-cer-06.png')
        }
      ]
    }
  }
}
